import { initJs } from './js'
import './styles/app.scss';

initJs();